import { ALL_WHITELIST_BLOCKCHAINS_VALUE } from '../const';

export const hasAllBlockchainsInWhitelist = (whitelistBlockchains: string[]) =>
  whitelistBlockchains.length === 0 ||
  whitelistBlockchains[0] === ALL_WHITELIST_BLOCKCHAINS_VALUE;
